import React, { useContext, useState, useEffect, useRef } from "react";
import MyContext from "../../context/MyContext";
import { Input } from "../styles/Input.styled";

const GoogleAddress = () => {
  const [address, setAddress] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const justSelected = useRef(false);
  const { dev, headers, setData } = useContext(MyContext);

  // Fetch autocomplete suggestions
  useEffect(() => {
    if (address.length < 3 || justSelected.current) {
      setSuggestions([]);
      return;
    }

    const fetchSuggestions = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          dev
            ? `http://localhost:5000/api/places/autocomplete?input=${encodeURIComponent(
                address
              )}`
            : `api/places/autocomplete?input=${encodeURIComponent(address)}`,
          {
            headers: headers,
          }
        );
        const data = await response.json();
        if (response.ok) {
          setSuggestions(data);
        } else {
          console.error("Error fetching suggestions:", data.error);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      } finally {
        setLoading(false);
      }
    };

    const debounce = setTimeout(fetchSuggestions, 300);
    return () => clearTimeout(debounce);
  }, [address, dev, headers]);

  // Handle address input change
  const handleAddressChange = (e) => {
    setAddress(e.target.value);
    justSelected.current = false;
  };

  // Handle suggestion selection
  const handleSelect = async (selectedAddress) => {
    justSelected.current = true;
    setAddress(selectedAddress);
    setSuggestions([]);
    try {
      const response = await fetch(
        dev
          ? `http://localhost:5000/api/places/geocode?address=${encodeURIComponent(
              selectedAddress
            )}`
          : `api/places/geocode?address=${encodeURIComponent(selectedAddress)}`,
        {
          headers: headers,
        }
      );
      const data = await response.json();
      if (response.ok) {
        setData((prevValue) => ({
          ...prevValue,
          streetAddress: data.streetAddress,
          suburb: data.suburb,
          city: data.city,
          province: data.province,
          postalCode: data.postalCode,
        }));
      } else {
        console.error("Error geocoding address:", data.error);
      }
    } catch (error) {
      console.error("Error geocoding address:", error);
    }
  };

  return (
    <div style={{ padding: "0 1% 0 0" }}>
      <Input
        value={address}
        onChange={handleAddressChange}
        placeholder="Search Places..."
        className="location-search-input"
      />
      <div className="autocomplete-dropdown-container">
        {loading && <div>Loading...</div>}
        {suggestions.length > 0 &&
          suggestions.map((suggestion, index) => {
            const className = "suggestion-item";
            return (
              <div
                key={index}
                className={className}
                onClick={() => handleSelect(suggestion.description)}
                style={{
                  cursor: "pointer",
                  padding: "5px",
                  backgroundColor: "#fff",
                }}
              >
                <span>{suggestion.description}</span>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default GoogleAddress;
